//========================================================================================
/*
  children,         [comp]
  screenTitle,      [str]
  percent,          [number]
  backBtnAction,    [func]
  nextBtnTitle,     [str || continue]
  nextBtnAction,    [func]
  nextBtnDisabled   [bool]
 */
//========================================================================================


import React from 'react';
import { translate } from 'react-i18next';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';

// Components
import ExtComp from '../external';

import { clearNewJob } from '../../reducer/createNewJobActions';

// Style
import s from './NewJobWrapper.style';


const NewJobWrapper = (props) => {
  const { children, dispatch, screenTitle, percent, backPath, nextBtnTitle, nextBtnAction, nextBtnDisabled, t } = props;

  const backToJobs = () => {
    dispatch(clearNewJob());
    dispatch(push('/practitioner/jobs'));
  };

  const backTo = () => {
    dispatch(push(backPath));
  };

  return (
    <s.NewJobWrapper percent={percent}>

      <ExtComp.InternalHeader />

      {/* ──── Caption ─────────────────────────────────────────────────────────────────────────── */}
      <div className="screen-caption">
        <div className="cancel-new-job">
          <button title="cancel job" onClick={backToJobs}>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
              <g fill="none" fillRule="evenodd">
                <path d="M-5-5h24v24H-5z" />
                <path fill="#A2A4B2" fillRule="nonzero" d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z" />
              </g>
            </svg>
          </button>

          <p>{t('nj_create_common_title')}</p>
        </div>

        <p className="screen-title">{screenTitle}</p>
      </div>

      {/* ──── Content ─────────────────────────────────────────────────────────────────────────── */}
      <div className="content">
        {children}
      </div>


      {/* ──── Footer ──────────────────────────────────────────────────────────────────────────── */}
      <div className="footer">
        <div className="btns-wrapper">
          {backPath ? <button type="button" className="btn-like-link" onClick={backTo}>{t('back')}</button> : null}

          <button
            type="button"
            onClick={nextBtnAction}
            className="btn-primary"
            disabled={nextBtnDisabled}
          >
            {nextBtnTitle || t('continue')}
          </button>

        </div>

      </div>

    </s.NewJobWrapper>
  );
};

export default translate()(
  connect()(NewJobWrapper)
);